import type { JSX } from 'react';
import { Button, Modal, ModalActions, ModalContent, ModalTitleInfo } from '@c2fo/liquidity';
import trashCan from '@/enterprise/assets/trashcan.svg?url';
import { MANUAL_CUSTOMERS_CONTENT } from './content';

interface RemoveCustomerModalProps {
  customerName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const RemoveCustomerModal = ({ customerName, onClose, onConfirm }: RemoveCustomerModalProps): JSX.Element => (
  <Modal open onClose={onClose} size="sm">
    <ModalTitleInfo>{`${MANUAL_CUSTOMERS_CONTENT.removeCustomer.titleLead} ${customerName}`}</ModalTitleInfo>
    <ModalContent>
      <img alt="" className="mx-auto mb-4" src={trashCan} width={51} height={53} />
      <p className="p-2">
        {MANUAL_CUSTOMERS_CONTENT.removeCustomer.bodyLead}
        <strong>{customerName}</strong>
        {MANUAL_CUSTOMERS_CONTENT.removeCustomer.bodyTail}
      </p>
    </ModalContent>
    <ModalActions>
      <Button variant="secondary" onClick={onClose}>
        {MANUAL_CUSTOMERS_CONTENT.removeCustomer.cancel}
      </Button>
      <Button variant="destructive" onClick={onConfirm}>
        {MANUAL_CUSTOMERS_CONTENT.removeCustomer.confirm}
      </Button>
    </ModalActions>
  </Modal>
);
